import { v4 as uuidv4 } from 'uuid';
import { formatFileSize } from './localFile.js';
import {
	isLocalMediaItem,
	normalizeUploadedImageItem,
	pickFilesizeByte,
	pickFilesizeLabel,
} from './mediaItem.js';

/** 为 false 时走 uploadMediaToQiniu 真实上传 */
export const USE_LOCAL_IMAGE_MOCK = false;

export const MAX_LOCAL_IMAGES = 9;
export const MAX_LOCAL_IMAGE_SIZE = 20 * 1024 * 1024;

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp|svg)$/i;

export function isLocalImageFile(file) {
	if (!file) return false;
	if (file.type && file.type.startsWith('image/')) {
		return true;
	}
	return IMAGE_EXT.test(file.name || '');
}

export function createLocalImageItem(file) {
	return {
		id: uuidv4(),
		filename: file.name,
		filesize: formatFileSize(file.size),
		filesize_byte: file.size,
		previewUrl: URL.createObjectURL(file),
		url: '',
		local: true,
	};
}

export function revokeLocalImageUrl(url) {
	if (url?.startsWith('blob:')) {
		URL.revokeObjectURL(url);
	}
}

export function revokeLocalImages(images = []) {
	images.forEach((item) => revokeLocalImageUrl(item.previewUrl));
}

export function filterValidLocalFiles(files = [], maxCount = MAX_LOCAL_IMAGES) {
	const valid = [];
	for (const file of files) {
		if (!isLocalImageFile(file)) continue;
		if (file.size > MAX_LOCAL_IMAGE_SIZE) continue;
		valid.push(file);
		if (valid.length >= maxCount) break;
	}
	return valid;
}

export function normalizeLocalImageItem(item = {}) {
	if (!isLocalMediaItem(item)) {
		return normalizeUploadedImageItem(item);
	}
	return {
		id: item.id || uuidv4(),
		filename: item.filename || '',
		filesize: pickFilesizeLabel(item),
		filesize_byte: pickFilesizeByte(item),
		previewUrl: item.previewUrl || item.url || '',
		url: '',
		local: true,
	};
}

/** 合并 fallback 后规范化图片项（编辑态 / 生成提交共用） */
export function normalizeStoredImageItem(image = {}, fallback = {}) {
	const merged = { ...fallback, ...image };
	const normalized = normalizeLocalImageItem(merged);
	if (!normalized.previewUrl && !normalized.url) {
		return fallback?.previewUrl || fallback?.url ? { ...fallback } : normalized;
	}
	return {
		...normalized,
		id: image.id || normalized.id || fallback?.id,
	};
}

export function normalizeLocalImages(images = []) {
	return images.map(normalizeLocalImageItem);
}

export function normalizeHeaderImages(data = {}) {
	const displayMode = data.displayMode === 'carouselSlice' ? 'carousel' : data.displayMode;
	const sourceItems = Array.isArray(data.items)
		? data.items
		: (Array.isArray(data.images) ? data.images : []);
	const imageStyle = data.imageStyle === 'topFull'
		? 'full'
		: (data.imageStyle || 'full');
	return {
		imageStyle,
		displayMode: displayMode || 'carousel',
		items: normalizeLocalImages(sourceItems),
	};
}
